import { paramCase } from 'src/utils/change-case';

import { _id, _postTitles } from 'src/_mock/assets';

// ----------------------------------------------------------------------

const MOCK_ID = _id[1];

const MOCK_TITLE = _postTitles[2];

const ROOTS = {
  AUTH: '/auth',
  AUTH_DEMO: '/auth-demo',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/error/403',
  page404: '/error/404',
  page500: '/error/500',
  components: '/components',
  docs: 'https://docs.minimals.cc',
  changelog: 'https://docs.minimals.cc/changelog',
  zoneStore: 'https://mui.com/store/items/zone-landing-page/',
  minimalStore: 'https://mui.com/store/items/minimal-dashboard/',
  freeUI: 'https://mui.com/store/items/minimal-dashboard-free/',
  figma: 'https://www.figma.com/design/cAPz4pYPtQEXivqe11EcDE/%5BPreview%5D-Minimal-Web.v6.0.0',
  product: {
    root: `/product`,
    checkout: `/product/checkout`,
    details: (id) => `/product/${id}`,
    demo: { details: `/product/${MOCK_ID}` },
  },
  post: {
    root: `/post`,
    details: (title) => `/post/${paramCase(title)}`,
    demo: { details: `/post/${paramCase(MOCK_TITLE)}` },
  },
  // AUTH
  auth: {
    amplify: {
      signIn: `${ROOTS.AUTH}/amplify/sign-in`,
      verify: `${ROOTS.AUTH}/amplify/verify`,
      signUp: `${ROOTS.AUTH}/amplify/sign-up`,
      updatePassword: `${ROOTS.AUTH}/amplify/update-password`,
      resetPassword: `${ROOTS.AUTH}/amplify/reset-password`,
    },
    jwt: {
      signIn: `${ROOTS.AUTH}/jwt/sign-in`,
      signUp: `${ROOTS.AUTH}/jwt/sign-up`,
    },
    firebase: {
      signIn: `${ROOTS.AUTH}/firebase/sign-in`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      signUp: `${ROOTS.AUTH}/firebase/sign-up`,
      resetPassword: `${ROOTS.AUTH}/firebase/reset-password`,
    },
    auth0: {
      signIn: `${ROOTS.AUTH}/auth0/sign-in`,
    },
    supabase: {
      signIn: `${ROOTS.AUTH}/supabase/sign-in`,
      verify: `${ROOTS.AUTH}/supabase/verify`,
      signUp: `${ROOTS.AUTH}/supabase/sign-up`,
      updatePassword: `${ROOTS.AUTH}/supabase/update-password`,
      resetPassword: `${ROOTS.AUTH}/supabase/reset-password`,
    },
  },
  authDemo: {
    split: {
      signIn: `${ROOTS.AUTH_DEMO}/split/sign-in`,
      signUp: `${ROOTS.AUTH_DEMO}/split/sign-up`,
      resetPassword: `${ROOTS.AUTH_DEMO}/split/reset-password`,
      updatePassword: `${ROOTS.AUTH_DEMO}/split/update-password`,
      verify: `${ROOTS.AUTH_DEMO}/split/verify`,
    },
    centered: {
      signIn: `${ROOTS.AUTH_DEMO}/centered/sign-in`,
      signUp: `${ROOTS.AUTH_DEMO}/centered/sign-up`,
      resetPassword: `${ROOTS.AUTH_DEMO}/centered/reset-password`,
      updatePassword: `${ROOTS.AUTH_DEMO}/centered/update-password`,
      verify: `${ROOTS.AUTH_DEMO}/centered/verify`,
    },
  },
  // DASHBOARD
  dashboard: {
    agilis: {
      overview: `${ROOTS.DASHBOARD}/overview`,
      facescan: `${ROOTS.DASHBOARD}/facescan`,
      inbound: {
        root: `${ROOTS.DASHBOARD}/inbound`,
        // faceScan: `${ROOTS.DASHBOARD}/inbound/import-goods`,
        importGoods: `${ROOTS.DASHBOARD}/inbound/import-goods/add-product-and-insert-pallet`,
      },
      outbound: {
        root: `${ROOTS.DASHBOARD}/outbound`,
        requisition: `${ROOTS.DASHBOARD}/outbound/requisition/asrs-pay`,
        damaged: `${ROOTS.DASHBOARD}/outbound/damaged`,
        adjustStock: `${ROOTS.DASHBOARD}/outbound/damaged/adjust-stock`,
        pallet: `${ROOTS.DASHBOARD}/outbound/pallet`,
        palletRetrieval: `${ROOTS.DASHBOARD}/outbound/pallet/pallet-retrieval-by-barcode`,
        callPalletByPallet: `${ROOTS.DASHBOARD}/outbound/call-pallet/call-pallet-by-pallet`,
        request: `${ROOTS.DASHBOARD}/outbound/request`,
        transfer_branch: `${ROOTS.DASHBOARD}/outbound/request/transfer-branch`,
      },
      general: {
        root: `${ROOTS.DASHBOARD}/general`,
        queue: `${ROOTS.DASHBOARD}/general/queue`,
        palletRackTable: `${ROOTS.DASHBOARD}/general/pallet-rack`,
        checkPickingList: `${ROOTS.DASHBOARD}/general/check-picking`,
        utilization: `${ROOTS.DASHBOARD}/general/utilization`,
        groupPallet: `${ROOTS.DASHBOARD}/general/utilization/group-pallet`,
        countStock: `${ROOTS.DASHBOARD}/general/count-stock`,
        checkPallet: `${ROOTS.DASHBOARD}/general/count-stock/check-pallet`,
        rop: `${ROOTS.DASHBOARD}/general/rop`,
      },
      admin: {
        root: `${ROOTS.DASHBOARD}/admin`,
        group: `${ROOTS.DASHBOARD}/admin/group`,
        subgroup: `${ROOTS.DASHBOARD}/admin/subgroup`,
        menu: `${ROOTS.DASHBOARD}/admin/menu`,
        dictionary: `${ROOTS.DASHBOARD}/admin/dictionary`,
        reservation: `${ROOTS.DASHBOARD}/admin/reservation`,
        dc: `${ROOTS.DASHBOARD}/admin/dc`,
        overview: `${ROOTS.DASHBOARD}/admin/overview`,
        afterServicesReport: `${ROOTS.DASHBOARD}/admin/receive-case`,
        afterServicesReportHistory: `${ROOTS.DASHBOARD}/admin/receive-case-history`,
        afterServicesReportAnalytics: `${ROOTS.DASHBOARD}/admin/receive-case-analytics`,
        annoucement: `${ROOTS.DASHBOARD}/admin/annoucement`,
        fixPalletPos: `${ROOTS.DASHBOARD}/admin/fix-pallet-position`,
      },
      tools: {
        root: `${ROOTS.DASHBOARD}/tools`,
        faceScan: `${ROOTS.DASHBOARD}/tools/face-scan`,
        tools: `${ROOTS.DASHBOARD}/tools/tools`,
        personalFace: `${ROOTS.DASHBOARD}/tools/personal-face`,
      },
      centeralized: {
        root: `${ROOTS.DASHBOARD}/centralized`,
        user: `${ROOTS.DASHBOARD}/centralized/user`,
        masterProduct: `${ROOTS.DASHBOARD}/centralized/add-master`,
        rights: `${ROOTS.DASHBOARD}/centralized/rights`,
        faceRegistration: `${ROOTS.DASHBOARD}/centralized/face-registration`,
      },
      reportChart: {
        root: `${ROOTS.DASHBOARD}/report-chart`,
        serviceLevel: `${ROOTS.DASHBOARD}/report-chart/service-level`,
        mobileCheckStock: `${ROOTS.DASHBOARD}/report-chart/mobile-check-stock`,
        productListingInformation: `${ROOTS.DASHBOARD}/report-chart/product-listing-information`,
        taskScheduler: `${ROOTS.DASHBOARD}/report-chart/task-scheduler`,
        negativeGoods: `${ROOTS.DASHBOARD}/report-chart/negative-goods`,
      },
      reportChartOverviewAdmin: {
        root: `${ROOTS.DASHBOARD}/report-overview-admin`,
        dashboardUtilize: `${ROOTS.DASHBOARD}/report-overview-admin/dashboard-utilize`,
        shelfUsage: `${ROOTS.DASHBOARD}/report-overview-admin/shelf-usage`,
        proportionASRS: `${ROOTS.DASHBOARD}/report-overview-admin/proportion-asrs`,
        palletsWaitingForStorage: `${ROOTS.DASHBOARD}/report-overview-admin/pallets-waiting-for-storage`,
        shelfStatus: `${ROOTS.DASHBOARD}/report-overview-admin/shelf-status`,
        rop: `${ROOTS.DASHBOARD}/report-overview-admin/rop`,
        manuallyWithdrawProductsFromASRS: `${ROOTS.DASHBOARD}/report-overview-admin/manually-withdraw-products-from-asrs`,
        reports: {
          breakdownReport: `${ROOTS.DASHBOARD}/report-overview-admin/reports/breakdown-dashboard`,
          informationReport: `${ROOTS.DASHBOARD}/report-overview-admin/reports/information-dashboard`,
          maincaseReport: `${ROOTS.DASHBOARD}/report-overview-admin/reports/maincase-dashboard`,
          monitorReport: `${ROOTS.DASHBOARD}/report-overview-admin/reports/monitor-dashboard`,
          productPalletReport: `${ROOTS.DASHBOARD}/report-overview-admin/reports/product-pallet-dashboard`,
          reorderPointReport: `${ROOTS.DASHBOARD}/report-overview-admin/reports/reorder-point-dashboard`,
          serviceRankingReport: `${ROOTS.DASHBOARD}/report-overview-admin/reports/service-ranking-dashboard`,
          utilizationReport: `${ROOTS.DASHBOARD}/report-overview-admin/reports/utilization-dashboard`,
          licenseplate: `${ROOTS.DASHBOARD}/report-overview-admin/license-plate`,
          CaseCategoryReport: `${ROOTS.DASHBOARD}/report-overview-admin/reports/case-category-report`,
        },
      },
    },
    root: ROOTS.DASHBOARD,
    mail: `${ROOTS.DASHBOARD}/mail`,
    chat: `${ROOTS.DASHBOARD}/chat`,
    blank: `${ROOTS.DASHBOARD}/blank`,
    kanban: `${ROOTS.DASHBOARD}/kanban`,
    calendar: `${ROOTS.DASHBOARD}/calendar`,
    fileManager: `${ROOTS.DASHBOARD}/file-manager`,
    permission: `${ROOTS.DASHBOARD}/permission`,
    general: {
      app: `${ROOTS.DASHBOARD}/app`,
      ecommerce: `${ROOTS.DASHBOARD}/ecommerce`,
      analytics: `${ROOTS.DASHBOARD}/analytics`,
      banking: `${ROOTS.DASHBOARD}/banking`,
      booking: `${ROOTS.DASHBOARD}/booking`,
      file: `${ROOTS.DASHBOARD}/file`,
      course: `${ROOTS.DASHBOARD}/course`,
    },
    user: {
      root: `${ROOTS.DASHBOARD}/user`,
      new: `${ROOTS.DASHBOARD}/user/new`,
      list: `${ROOTS.DASHBOARD}/user/list`,
      cards: `${ROOTS.DASHBOARD}/user/cards`,
      profile: `${ROOTS.DASHBOARD}/user/profile`,
      account: `${ROOTS.DASHBOARD}/user/account`,
      edit: (id) => `${ROOTS.DASHBOARD}/user/${id}/edit`,
      demo: {
        edit: `${ROOTS.DASHBOARD}/user/${MOCK_ID}/edit`,
      },
    },
    product: {
      root: `${ROOTS.DASHBOARD}/product`,
      new: `${ROOTS.DASHBOARD}/product/new`,
      details: (id) => `${ROOTS.DASHBOARD}/product/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/product/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/product/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/product/${MOCK_ID}/edit`,
      },
    },
    invoice: {
      root: `${ROOTS.DASHBOARD}/invoice`,
      new: `${ROOTS.DASHBOARD}/invoice/new`,
      details: (id) => `${ROOTS.DASHBOARD}/invoice/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/invoice/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}/edit`,
      },
    },
    post: {
      root: `${ROOTS.DASHBOARD}/post`,
      new: `${ROOTS.DASHBOARD}/post/new`,
      details: (title) => `${ROOTS.DASHBOARD}/post/${paramCase(title)}`,
      edit: (title) => `${ROOTS.DASHBOARD}/post/${paramCase(title)}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/post/${paramCase(MOCK_TITLE)}`,
        edit: `${ROOTS.DASHBOARD}/post/${paramCase(MOCK_TITLE)}/edit`,
      },
    },
    order: {
      root: `${ROOTS.DASHBOARD}/order`,
      details: (id) => `${ROOTS.DASHBOARD}/order/${id}`,
      demo: {
        details: `${ROOTS.DASHBOARD}/order/${MOCK_ID}`,
      },
    },
    job: {
      root: `${ROOTS.DASHBOARD}/job`,
      new: `${ROOTS.DASHBOARD}/job/new`,
      details: (id) => `${ROOTS.DASHBOARD}/job/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/job/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/job/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/job/${MOCK_ID}/edit`,
      },
    },
    tour: {
      root: `${ROOTS.DASHBOARD}/tour`,
      new: `${ROOTS.DASHBOARD}/tour/new`,
      details: (id) => `${ROOTS.DASHBOARD}/tour/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/tour/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}/edit`,
      },
    },
  },
};
